import { render } from "./FormularioCentroActivacion.vue?vue&type=template&id=4fc6ca0e&scoped=true"
import script from "./FormularioCentroActivacion.vue?vue&type=script&lang=js"
export * from "./FormularioCentroActivacion.vue?vue&type=script&lang=js"

import "./FormularioCentroActivacion.vue?vue&type=style&index=0&id=4fc6ca0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc6ca0e"]])

export default __exports__